export const FLUJOS_APPLICATION_CODE = 'FLUJOS';

const getApplicationCode = (application) => (
  application?.code ||
  application?.applicationCode ||
  application?.application?.code ||
  ''
).toUpperCase();

export const hasApplicationAccess = (authData, applicationCode = FLUJOS_APPLICATION_CODE) => {
  const applications = authData?.applications || [];
  const normalizedCode = String(applicationCode).toUpperCase();

  return applications.some((application) => getApplicationCode(application) === normalizedCode);
};
